import { createContext, useContext, useMemo, useState, type ReactNode } from 'react';
import { IconButton } from '@/components/ui/icon-button';
import { AccountSheet } from './account-sheet';

interface AccountApi {
  open: () => void;
}

const AccountContext = createContext<AccountApi | null>(null);

/** Owns the Account sheet open state and mounts it once for the authed shell. */
export function AccountProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);
  const api = useMemo<AccountApi>(() => ({ open: () => setOpen(true) }), []);
  return (
    <AccountContext.Provider value={api}>
      {children}
      <AccountSheet open={open} onClose={() => setOpen(false)} />
    </AccountContext.Provider>
  );
}

export function useAccount(): AccountApi {
  return useContext(AccountContext) ?? { open: () => {} };
}

/** AppBar right-slot button that opens the Account sheet. */
export function AccountButton() {
  const { open } = useAccount();
  return <IconButton name="user" label="Account" bare onClick={open} />;
}
